export enum ShowStatus {
    AWAITING_PRIZE_LIST = "awaiting_prize_list",
    PRE_ENTRY = "pre_entry",
    PRIORITY_ENTRY = "priority_entry",
    OPEN_GENERAL_ENTRY = "open_general_entry",
    CLOSED_ENTRY = "closed_entry",
    GENREATED_PROGRAM = "generated_program",
    AWAITING_RESULT = "awaiting_result",
    COMPLETED = "completed",
}
